
import React, { Component } from "react";
import {Text, Tag} from "@chakra-ui/react";


export default class MultiEntryKeyPairDisplay extends Component 
{


    render() 
    {
        var keyProp = this.props.card.keyProp;
        var valueProp = this.props.card.valueProp;
        var isNewFormat = this.props.cardValue[0][keyProp];
        var newCardValue = (isNewFormat) ? this.props.cardValue :
            this.props.cardValue.map((cv) => 
            {
                var newVal = {};
                newVal[keyProp] = cv[keyProp];
                newVal[valueProp] = cv[valueProp];
                return newVal;
            })
        return(                
            <Text fontSize={{ base: '14px', md: '20px', lg: '24px' }} color="#0095c8" margin='0'>{newCardValue.map((v) => {return <Tag margin={'2px'}>{v[this.props.card.keyProp]}-{v[this.props.card.valueProp]}</Tag>})}</Text>
        )
    }
}







